export default "__VITE_ASSET__MiLLxTA$__"